import React from "react";
import {useTranslation} from "react-i18next";
import "../../i18n/config";
import {Tooltip} from "../common/Tooltip";
import "../common/SquareButton.css";
import "./AlignmentButton.css";
import {
    AlignmentType,
    BLOCK_STYLE_ALIGN_CENTER,
    BLOCK_STYLE_ALIGN_LEFT,
    BLOCK_STYLE_ALIGN_RIGHT
} from "./CellEditor/EditorCommon";


type AlignmentButtonsProps = {
    tooltip?: string;
    disabled?: boolean;
    activeType?: string;
    onClick?: (alignment_type: AlignmentType, e: React.MouseEvent<HTMLElement>) => void;
}

export const AlignmentButtons = (props: AlignmentButtonsProps) => {
    const {t} = useTranslation();
    return (
        <>
            <AlignmentButton className="alignment_button-left"
                             tooltip={t("左寄せ")}
                             disabled={props.disabled === true}
                             active={props.activeType === BLOCK_STYLE_ALIGN_LEFT}
                             onClick={(e) => props.onClick?.(BLOCK_STYLE_ALIGN_LEFT, e)}/>

            <AlignmentButton className="alignment_button-center"
                             tooltip={t("中央寄せ")}
                             disabled={props.disabled === true}
                             active={props.activeType === BLOCK_STYLE_ALIGN_CENTER}
                             onClick={(e) => props.onClick?.(BLOCK_STYLE_ALIGN_CENTER, e)}/>

            <AlignmentButton className="alignment_button-right"
                             tooltip={t("右寄せ")}
                             disabled={props.disabled === true}
                             active={props.activeType === BLOCK_STYLE_ALIGN_RIGHT}
                             onClick={(e) => props.onClick?.(BLOCK_STYLE_ALIGN_RIGHT, e)}/>
        </>
    );
}

type AlignmentButtonProps = {
    className: string;
    tooltip?: string;
    disabled?: boolean;
    active?: boolean;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const AlignmentButton = (props: AlignmentButtonProps) => {
    return (
        <Tooltip title={props.tooltip ?? ''}>
                <span className={`alignment-button square-button ${props.className}`}
                      aria-disabled={props.disabled === true}
                      data-active={props.active === true}
                      onClick={props.onClick}>&nbsp;</span>
        </Tooltip>
    );
}
